export default __webpack_public_path__ + "static/media/tablet_vertical.536b2a19.svg";